import React from 'react';

const ShopSettings: React.FC = () => {
  return (
    <div className="shop-settings">
      <h1>Shop-Einstellungen</h1>
      <p>Konfiguration der Shop-Parameter.</p>
    </div>
  );
};

export default ShopSettings;
